/**
 * Converts an object of params to a query string.
 * @param params
 */
export function paramsToQuery(params) {
    const query = new URLSearchParams();
    Object.keys(params).forEach(key => {
        const value = params[key];
        if (value) {
            if (typeof value === 'string')
                query.append(key, value);
            else if (typeof value === 'boolean')
                query.append(key, String(value));
            else
                value.forEach((valuePart) => query.append(key, String(valuePart)));
        }
    });
    return query.toString();
}
//# sourceMappingURL=Utils.js.map